/** Firestore doc: companies/{companyId}/agile_settings/ai_orchestration */

export const AI_ORCHESTRATION_DOC_ID = 'ai_orchestration';

export const SCRUM_MASTER_TRIGGERS = [
  {
    id: 'onEpicCreation',
    label: 'On Epic Creation (Break down into Developer Tasks)',
  },
  {
    id: 'onTaskCompletion',
    label: 'On Task Completion (Code Review & Update MAD)',
  },
  {
    id: 'onSprintStart',
    label: 'On Sprint Start (Assign Tasks to Agent Roster)',
  },
];

/**
 * @returns {import('./agileAiOrchestration').AiOrchestrationSettings}
 */
export function createDefaultAiOrchestrationSettings() {
  return {
    enabled: false,
    masterArchitectureDocument: '',
    triggers: {
      onEpicCreation: true,
      onTaskCompletion: true,
      onSprintStart: true,
    },
  };
}

/**
 * @param {object | null | undefined} raw
 * @returns {import('./agileAiOrchestration').AiOrchestrationSettings}
 */
export function normalizeAiOrchestrationSettings(raw) {
  const defaults = createDefaultAiOrchestrationSettings();
  if (!raw || typeof raw !== 'object') return defaults;
  return {
    enabled: Boolean(raw.enabled),
    masterArchitectureDocument:
      typeof raw.masterArchitectureDocument === 'string' ?
        raw.masterArchitectureDocument :
        '',
    triggers: {
      onEpicCreation: raw.triggers?.onEpicCreation ?? defaults.triggers.onEpicCreation,
      onTaskCompletion: raw.triggers?.onTaskCompletion ?? defaults.triggers.onTaskCompletion,
      onSprintStart: raw.triggers?.onSprintStart ?? defaults.triggers.onSprintStart,
    },
  };
}

/**
 * @param {object | null | undefined} task
 * @returns {boolean}
 */
export function isTaskAssignedToAiAgent(task) {
  return Boolean(task?.isAssignedToAi && task?.assigneeAgentId);
}

/**
 * @param {string} assigneeKey
 * @returns {{ assigneeUid: string | null, assigneeAgentId: string | null, isAssignedToAi: boolean }}
 */
export function buildTaskAssignmentFromKey(assigneeKey) {
  if (!assigneeKey) {
    return { assigneeUid: null, assigneeAgentId: null, isAssignedToAi: false };
  }
  if (assigneeKey.startsWith('ai:')) {
    return {
      assigneeUid: null,
      assigneeAgentId: assigneeKey.slice(3),
      isAssignedToAi: true,
    };
  }
  if (assigneeKey.startsWith('human:')) {
    return {
      assigneeUid: assigneeKey.slice(6) || null,
      assigneeAgentId: null,
      isAssignedToAi: false,
    };
  }
  return { assigneeUid: null, assigneeAgentId: null, isAssignedToAi: false };
}

/**
 * @param {object | null | undefined} task
 * @returns {string}
 */
export function taskAssigneeKey(task) {
  if (task?.isAssignedToAi && task?.assigneeAgentId) {
    return `ai:${task.assigneeAgentId}`;
  }
  if (task?.assigneeUid) return `human:${task.assigneeUid}`;
  return '';
}
